import React from "react";
import styled from "styled-components";
import { Button } from "../../../../../design-system";
import AdsGenerator from "../../AdsGenerator";
import { useMediaStudio } from "../../context/MediaStudioContext";
import { SectionRoot } from "../shared";

// Hosts the community-level ad generator inside the Create flow.

const Frame = styled.div`
  width: 100%;
  background: var(--color-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  padding: var(--space-5);
  min-height: 60vh;
`;

const BackRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-2);
`;

export const AdsStudio: React.FC<{ onBack: () => void }> = ({ onBack }) => {
  const { communityId, mediaConfig } = useMediaStudio();

  return (
    <SectionRoot>
      <BackRow>
        <Button variant="ghost" size="sm" onClick={onBack}>
          ← All formats
        </Button>
      </BackRow>
      <Frame>
        <AdsGenerator
          communityId={communityId}
          hasAudienceData={mediaConfig.hasAudienceData}
        />
      </Frame>
    </SectionRoot>
  );
};

export default AdsStudio;
